import './Blogs.css';
import Blog from './pages/projects/components/Blog';
import blog1 from './images/blog1.webp';
import blog2 from './images/blog2.webp';
import blog3 from './images/blog3.webp';
import blog4 from './images/blog4.webp';
import Footer from './toolbar/Footer';
import ScrollToTop from 'react-scroll-to-top';
import PageTransition from './pageTransition';
import GrainOverlay from './GrainOverlay';
import { motion, useInView } from 'framer-motion';
import { useRef } from 'react';
import { staggerContainer, fadeUp } from './motionVariants';

const Blogs = () => {
    const ref = useRef(null);
    const isInView = useInView(ref, { once: true, margin: "-40px" });

    return (
        <>
        <PageTransition>
            <div className="Blogs">
                <section className="blogs-header grain-light">
                    <GrainOverlay intensity={0.06} />
                    <div className="blogs-header-inner">
                        <span className="blogs-label">INSIGHTS</span>
                        <h1 className="blogs-title">Writing & Thoughts</h1>
                    </div>
                </section>
                <motion.div
                    className="blogs-grid"
                    ref={ref}
                    variants={staggerContainer(0.12, 0.1)}
                    initial="hidden"
                    animate={isInView ? "visible" : "hidden"}
                >
                    <motion.div variants={fadeUp}>
                        <Blog
                            imageUrl={blog4}
                            title="Want to advance your career in tech? It's all about trust"
                            redirectUrl="https://wearetechwomen.com/want-to-advance-your-career-in-tech-its-all-about-trust"
                        />
                    </motion.div>
                    <motion.div variants={fadeUp}>
                        <Blog
                            imageUrl={blog1}
                            title="Embrace Abbreviations to Enhance UI"
                            redirectUrl="https://squirro.com/squirro-blog/17374"
                        />
                    </motion.div>
                    <motion.div variants={fadeUp}>
                        <Blog
                            imageUrl={blog2}
                            title="U, UX and the Fireman's Pole to Cognitive Search"
                            redirectUrl="https://squirro.com/squirro-blog/x-ux-and-the-firemans-pole-to-cognitive-search"
                        />
                    </motion.div>
                    <motion.div variants={fadeUp}>
                        <Blog
                            imageUrl={blog3}
                            title="Material Design: Stop Stalking, Start Following"
                            redirectUrl="https://squirro.com/squirro-blog/material-design-stop-stalking-start-following"
                        />
                    </motion.div>
                </motion.div>
            </div>
            <Footer/>
        </PageTransition>
        <ScrollToTop smooth className="scroll-to-top" />
        </>
    );
}

export default Blogs;
